import type { SVGProps } from 'react';

const Google = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M23.49 12.27c0-.79-.07-1.54-.2-2.27H12v4.29h6.44a5.37 5.37 0 0 1-2.33 3.52l3.76 2.91c2.2-2.03 3.62-5.03 3.62-8.45Z"
    />
    <path
      fill="#34A853"
      d="M12 24c3.24 0 5.96-1.06 7.95-2.88l-3.76-2.91c-1.05.7-2.4 1.12-4.19 1.12-3.12 0-5.77-2.11-6.72-4.96l-3.88 3A12 12 0 0 0 12 24Z"
    />
    <path
      fill="#FBBC05"
      d="M5.28 14.37A7.2 7.2 0 0 1 4.91 12c0-.82.14-1.61.37-2.37l-3.88-3A12 12 0 0 0 0 12c0 1.92.46 3.74 1.4 5.37l3.88-3Z"
    />
    <path
      fill="#EA4335"
      d="M12 4.67c1.89 0 3.58.65 4.91 1.93l3.58-3.58C17.95.68 15.24 0 12 0 7.31 0 3.25 2.69 1.4 6.63l3.88 3c.95-2.85 3.6-4.96 6.72-4.96Z"
    />
  </svg>
);

export { Google };
